import testimonial_image from '../assets/images/comment_placeholder.png';

const testimonials = [
    {
        name: 'Adanna Chukwuma',
        designation: 'Nurse, Abuja',
        testimony:
            'Before I came across the DMA Foundation, I was overwhelmed with stress and emotional burnout from work and life challenges. I didn’t even know I needed help — I just thought I was being weak. But after attending a mental health awareness session and speaking to one of their counselors, I began to heal. I now feel stronger, more focused, and more hopeful. I’m truly grateful for this support system.',
        image: {
            src: testimonial_image,
            alt: 'testimonial image',
        },
    },
    {
        name: 'Ibrahim Musa',
        designation: 'Undergraduate Student, Nasarawa',
        testimony:
            'As a young person dealing with depression, I felt alone. I couldn’t talk to anyone around me because they either didn’t understand or told me to pray it away. The DMA Foundation gave me someone to talk to and tools to manage my anxiety. Thanks to their volunteers and rehab sessions, I’m back in school and slowly rebuilding my confidence.',
        image: {
            src: testimonial_image,
            alt: 'testimonial image',
        },
    },
    {
        name: 'Ngozi Okeke',
        designation: 'Small Business Owner, Jos',
        testimony:
            'I lost my brother to addiction, and I was struggling with the trauma and guilt. The support I received from the DMA Foundation helped me process my grief and even support others going through similar experiences. Their work is life-changing, and I thank God for this foundation every day.',
        image: {
            src: testimonial_image,
            alt: 'testimonial image',
        },
    },
];

export default testimonials;
